import React from 'react';
import { Pressable, PressableProps } from 'react-native';
import { Text, styled } from '@tamagui/core';
import { YStack } from '@tamagui/stacks';

interface CustomButtonProps extends Omit<PressableProps, 'style'> {
  children?: React.ReactNode;
  backgroundColor?: string;
  color?: string;
  fontSize?: string | number;
  fontWeight?: string;
  padding?: string | number;
  paddingVertical?: string | number;
  paddingHorizontal?: string | number;
  borderRadius?: string | number;
  marginTop?: string | number;
  textAlign?: 'left' | 'center' | 'right';
  borderWidth?: number;
  borderColor?: string;
}

const StyledContainer = styled(YStack, {
  alignItems: 'center',
  justifyContent: 'center',
});

export const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  backgroundColor,
  color,
  fontSize,
  fontWeight,
  padding,
  paddingVertical,
  paddingHorizontal,
  borderRadius,
  marginTop,
  textAlign = 'center',
  borderWidth,
  borderColor,
  ...pressableProps
}) => {
  return (
    <Pressable 
      {...pressableProps}
      style={({ pressed }) => [
        {
          opacity: pressed ? 0.7 : 1,
          transform: [{ scale: pressed ? 0.98 : 1 }],
        },
      ]}
    >
      <StyledContainer
        backgroundColor={backgroundColor}
        padding={padding}
        paddingVertical={paddingVertical}
        paddingHorizontal={paddingHorizontal}
        borderRadius={borderRadius}
        marginTop={marginTop}
        borderWidth={borderWidth}
        borderColor={borderColor}
      >
        {typeof children === 'string' ? (
          <Text
            color={color}
            fontSize={fontSize}
            fontWeight={fontWeight}
            textAlign={textAlign}
          >
            {children}
          </Text>
        ) : (
          children
        )}
      </StyledContainer>
    </Pressable>
  );
};

export default CustomButton;
